<ng-container *ngIf="visible">
  <div class="rate-block-select" [class.rate-block-select--missing]="missingSelection">
    @if (variant === 'form') {
      <mat-form-field appearance="outline" class="hmt-form-field rate-block-field" [class.rate-block-field--loading]="loading">
        <mat-label *ngIf="label">{{ label }}</mat-label>
        <mat-select
          [value]="selectedKey"
          [disabled]="selectDisabled"
          [required]="required"
          [placeholder]="placeholder"
          (selectionChange)="onSelect($event)"
          data-testid="rate-block-select">
          <mat-option *ngFor="let option of options" [value]="option.key">
            {{ option.name }}
          </mat-option>
        </mat-select>
        <mat-spinner *ngIf="loading" matSuffix diameter="18" class="rate-block-spinner" data-testid="rate-block-loading"></mat-spinner>
      </mat-form-field>
      <div class="rate-block-error" *ngIf="missingSelection">
        No matching vehicle type &amp; size in this contract. Please select one.
      </div>
    } @else {
      <div class="rate-block-pill-wrapper">
        <mat-select
          class="rate-block-pill"
          [class.rate-block-pill--dark]="variant === 'pill-dark'"
          [class.rate-block-pill--missing]="missingSelection"
          [class.rate-block-pill--loading]="loading"
          panelClass="rate-block-pill-panel"
          [value]="selectedKey"
          [disabled]="selectDisabled"
          [required]="required"
          [placeholder]="placeholder"
          [matTooltip]="missingSelection ? 'No matching vehicle type & size in this contract. Please select one.' : null"
          (selectionChange)="onSelect($event)"
          data-testid="rate-block-select">
          <mat-option *ngFor="let option of options" [value]="option.key">
            {{ option.name }}
          </mat-option>
        </mat-select>
        <mat-spinner
          *ngIf="loading"
          diameter="12"
          class="rate-block-pill-spinner"
          [class.rate-block-pill-spinner--dark]="variant === 'pill-dark'"
          data-testid="rate-block-loading">
        </mat-spinner>
      </div>
    }
  </div>
</ng-container>
